// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"ce8b3188","787":"0bca8be2"}[chunkId] + ".chunk.js";
};